import { useFetchCallback } from '@services/services';
import { Integration } from '@utils/constants';
import toast from 'react-hot-toast';

export const useSyncIntegration = () => {
  const { call, isFetching } = useFetchCallback<{
    provider_type: string;
    provider_code: string;
    action?: string;
    config?: Record<string, unknown>;
  }>('post', '/v1/integrations/sync');

  const syncIntegration = async <T = unknown>(
    integration: Integration,
    options?: { action?: string; config?: Record<string, unknown>; notify?: boolean },
  ) => {
    const { action, config, notify = true } = options || {};
    try {
      const response = await call({
        data: {
          provider_type: integration.provider_type,
          provider_code: integration.provider_code,
          action,
          config,
        },
      });
      if (notify) {
        toast.success('Servicio sincronizado');
      }
      return response as T;
    } catch (error) {
      toast.error('Error al sincronizar el servicio');
      throw error;
    }
  };

  return {
    syncIntegration,
    isFetching,
  };
};
